"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getFilteredPayload;

var _get = _interopRequireDefault(require("lodash/get"));

var _head = _interopRequireDefault(require("lodash/head"));

var _reduce = _interopRequireDefault(require("lodash/reduce"));

var _set = _interopRequireDefault(require("lodash/set"));

var _isApiError = _interopRequireDefault(require("./is-api-error"));

var _getWhitelistedErrorFields = _interopRequireDefault(require("./get-whitelisted-error-fields"));

var _getErrorCode = _interopRequireDefault(require("./get-error-code"));

var _getApiErrors = _interopRequireDefault(require("./get-api-errors"));

/**
 * Get fields from error that are whitelisted to be sent to Rollbar.
 * @param {Object} error
 */
function getFields(error) {
  try {
    return (0, _getWhitelistedErrorFields.default)((0, _getErrorCode.default)(error));
  } catch (ignoredError) {
    return [];
  }
}
/**
 * Check the payload of the action for an error type. If the payload is an error, then only
 * whitelisted fields will be plucked out and returned.
 *
 * @param {Object} action - a redux action
 */


function getFilteredPayload(action) {
  if ((0, _isApiError.default)(action)) {
    var error = (0, _head.default)((0, _getApiErrors.default)(action));
    var fields = getFields(error);
    return (0, _reduce.default)(fields, function (result, current) {
      (0, _set.default)(result, current, (0, _get.default)(error, current));
      return result;
    }, {});
  }

  return undefined;
}